import { IGetGestaoRecebimentoEpiDropDownUseCase } from "../../../presentation/useCases/read/get_gestao_recebimento_epi_drop_down_use_case";
import { GestaoRecebimentoEpiDropdown } from "../../models/gestao_recebimento_epi_dropdown";
import { IGestaoEpiRepository } from "../../repositories/gestao_epi_repository";

export class GetGestaoRecebimentoEpiDropDownUseCase implements IGetGestaoRecebimentoEpiDropDownUseCase {
  constructor(private readonly repository: IGestaoEpiRepository) {}

  async getGestaoRecebimentoEpiDropDown(
    idCentroCusto?: number,
  ): Promise<GestaoRecebimentoEpiDropdown[]> {
    return await this.repository.getGestaoRecebimentoEpiDropDown(idCentroCusto);
  }
}
